import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks';
const selector = createSonarSelector((state) => state.core.tags.byIdMap);
export function useTagReference(tagId) {
    var _a;
    const { data } = useSonarSelector(selector);
    if (!tagId) {
        return {};
    }
    return (_a = data === null || data === void 0 ? void 0 : data[tagId]) !== null && _a !== void 0 ? _a : {};
}
